import React from 'react';
import '../../css/modal.css';
import { Customer } from '../../types/Customer';

interface CustomerInfoModalProps {
  customer?: Customer;
  onClose: () => void;
}

const CustomerInfoModal: React.FC<CustomerInfoModalProps> = ({ customer, onClose }) => {
  if (!customer) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <div className="modal-header">
          <h2>Customer Info</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <p><strong>Name:</strong> {customer.name}</p>
          <p><strong>Email:</strong> <a href={`mailto:${customer.email}`}>{customer.email}</a></p>
          <p><strong>Phone:</strong> <a href={`tel:${customer.phoneNumber}`}>{customer.phoneNumber}</a></p>
          <p><strong>City:</strong> {customer.city || '—'}</p>
          <p><strong>Source:</strong> {customer.source || '—'}</p>
          <p><strong>Area:</strong> {customer.area || '—'}</p>
          <p><strong>Address:</strong> {customer.address || '—'}</p>
          <p><strong>Profession:</strong> {customer.profession || '—'}</p>
          <p><strong>Description:</strong> {customer.description || '—'}</p>
          {customer.latitude && customer.longitude && (
            <p>
              <a
                href={`https://www.google.com/maps?q=${customer.latitude},${customer.longitude}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Navigate to Customer
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerInfoModal;
